import axios from "../../../services/axios-config.js";

export async function deleteUser({ userId }) {
    const res = await axios.delete(`/admin/users/${userId}`);
    return res?.data;
}
